import { Box } from '@mantine/core';
import { useParams } from 'wouter';
import { ProformaDocument } from '@/components/InvoiceDetailsModal/ProformaDocument';

/** The shareable proforma page. */
export default function InvoiceDetailsPage() {
  const { id } = useParams();
  return (
    <Box p="md">
      <ProformaDocument id={Number(id)} />
    </Box>
  );
}
